module.exports = __webpack_public_path__ + "static/fipcwhitegiraffe-ddfffd61ff24472a9f160270586a807a.jpeg";